var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "vc-filters" },
    [
      _vm.open
        ? _c("c-button-2", {
            staticClass: "vc-filters__toggler",
            attrs: { label: "Скрыть фильтры" },
            on: {
              click: function ($event) {
                _vm.open = false
              },
            },
          })
        : _vm._e(),
      _c("transition", { attrs: { name: "slide" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.open,
                expression: "open",
              },
            ],
            staticClass: "vc-filters__slide",
          },
          [
            _vm.inited
              ? _c(
                  "div",
                  { staticClass: "vc-filters__wrapper" },
                  [
                    _c("c-input2", {
                      ref: "periodPicker",
                      staticClass: "vc-filters__item vc-filters__period",
                      attrs: {
                        label: "За период",
                        placeholder: "00.00.0000 - 00.00.0000",
                        type: "period",
                        icon: "calendar",
                        clearable: true,
                        "icon-right": true,
                      },
                      model: {
                        value: _vm.form.period,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "period", $$v)
                        },
                        expression: "form.period",
                      },
                    }),
                    _c("c-input2", {
                      staticClass: "vc-filters__item vc-filters__filial",
                      attrs: {
                        type: "select",
                        label: "Филиал",
                        "checkbox-value": _vm.form.filialsExcept,
                        checkbox: true,
                        "checkbox-type": "icon",
                        "checkbox-tooltip": _vm.exceptTooltip,
                        multiple: true,
                        searchable: true,
                        placeholder: "Все",
                        items: _vm.collections.filials,
                      },
                      on: {
                        checkboxChange: function ($event) {
                          _vm.form.filialsExcept = $event
                        },
                      },
                      model: {
                        value: _vm.form.filials,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "filials", $$v)
                        },
                        expression: "form.filials",
                      },
                    }),
                    _c("c-input2", {
                      staticClass: "vc-filters__item vc-filters__position",
                      attrs: {
                        type: "select",
                        label: "Должность",
                        "checkbox-value": _vm.form.positionsExcept,
                        checkbox: true,
                        "checkbox-type": "icon",
                        "checkbox-tooltip": _vm.exceptTooltip,
                        multiple: true,
                        searchable: true,
                        placeholder: "Все",
                        items: _vm.collections.positions,
                      },
                      on: {
                        checkboxChange: function ($event) {
                          _vm.form.positionsExcept = $event
                        },
                      },
                      model: {
                        value: _vm.form.positions,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "positions", $$v)
                        },
                        expression: "form.positions",
                      },
                    }),
                    _c("c-input2", {
                      staticClass: "vc-filters__item vc-filters__types",
                      attrs: {
                        type: "select",
                        label: "Тип отпуска/больничный",
                        "checkbox-value": _vm.form.typesExcept,
                        checkbox: true,
                        "checkbox-type": "icon",
                        "checkbox-tooltip": _vm.exceptTooltip,
                        multiple: true,
                        searchable: true,
                        placeholder: "Все",
                        items: _vm.collections.types,
                      },
                      on: {
                        checkboxChange: function ($event) {
                          _vm.form.typesExcept = $event
                        },
                      },
                      model: {
                        value: _vm.form.types,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "types", $$v)
                        },
                        expression: "form.types",
                      },
                    }),
                    _c("c-input2", {
                      staticClass: "vc-filters__item vc-filters__name",
                      attrs: {
                        label: "ФИО",
                        clearable: true,
                        placeholder: "Любые",
                      },
                      on: {
                        enter: function ($event) {
                          return _vm.$emit("apply")
                        },
                      },
                      model: {
                        value: _vm.form.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "name", $$v)
                        },
                        expression: "form.name",
                      },
                    }),
                    _c(
                      "div",
                      { staticClass: "vc-filters__item vc-filters__actions" },
                      [
                        _c("c-button", {
                          staticClass: "vc-filters__reset",
                          attrs: { size: "large", label: "Сбросить" },
                          on: { click: _vm.reset },
                        }),
                        _c("c-button", {
                          staticClass: "vc-filters__apply",
                          attrs: {
                            label: "Применить",
                            color: "blue",
                            size: "large",
                          },
                          on: { click: _vm.apply },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        ),
      ]),
      _vm.open
        ? _c("c-button2", {
            staticClass: "vc-filters__toggler",
            attrs: { label: "Скрыть фильтры" },
            on: {
              click: function ($event) {
                _vm.open = false
              },
            },
          })
        : _vm._e(),
      !_vm.open
        ? _c("c-button2", {
            staticClass: "vc-filters__toggler",
            attrs: { label: "Показать фильтры" },
            on: {
              click: function ($event) {
                _vm.open = true
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }